import { http, HttpResponse } from 'msw';
import { env } from '@repo/env';
import { apiPaths } from '@repo/api/client';
import { loanAddMock } from './mocks/loan-add.mock';
var apiUrl = env.VITE_API_URL;
var apiEndpoint = apiPaths.loan.path;
export var loanAddHandler = [
    http.post("".concat(apiUrl).concat(apiEndpoint), function () {
        return HttpResponse.json(loanAddMock.successNew, {
            status: 200,
        });
    }),
];
// Scenario handlers for use via server.use(...)
export var loanAddErrorHandlers = {
    discountLoanAmountTooHigh: http.post("".concat(apiUrl).concat(apiEndpoint), function () {
        return HttpResponse.json(loanAddMock.discountSoftErrorLoanAmountTooHigh, {
            status: 422,
        });
    }),
    discountLoanAmountTooLow: http.post("".concat(apiUrl).concat(apiEndpoint), function () {
        return HttpResponse.json(loanAddMock.discountSoftErrorLoanAmountTooLow, {
            status: 422,
        });
    }),
    discountUsed: http.post("".concat(apiUrl).concat(apiEndpoint), function () {
        return HttpResponse.json(loanAddMock.discountSimpleErrorUsed, { status: 422 });
    }),
    discountCodeExpired: http.post("".concat(apiUrl).concat(apiEndpoint), function () {
        return HttpResponse.json(loanAddMock.discountSimpleErrorCodeExpired, {
            status: 422,
        });
    }),
    internalError: http.post("".concat(apiUrl).concat(apiEndpoint), function () {
        return HttpResponse.json(loanAddMock.internalError, { status: 500 });
    }),
};
